module.exports = __webpack_public_path__ + "images/qrCode.ce23d63.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/assets/image/qrCode.jpg
// module id = 642
// module chunks = 0